import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/svg/play-button-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-3d3f4f94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "video-el" }
const _hoisted_2 = {
  class: "video-el-main",
  ref: "videoMain",
  controls: "",
  playsinline: ""
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  class: "video-el-poster",
  ref: "videoPoster",
  muted: "",
  autoplay: "",
  playsinline: ""
}
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "image",
  src: _imports_0,
  alt: "play-icon"
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("video", _hoisted_2, [
      _createElementVNode("source", {
        src: _ctx.mediaData['galleryListProductModalGalleryDesktopVideo']
      }, null, 8, _hoisted_3)
    ], 512),
    _createElementVNode("video", _hoisted_4, [
      _createElementVNode("source", {
        src: _ctx.mediaData['galleryListProductModalGalleryDesktopVideo']
      }, null, 8, _hoisted_5)
    ], 512),
    _createElementVNode("button", {
      class: "btn play-button",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.start && _ctx.start(...args))),
      ref: "playButton"
    }, _hoisted_7, 512)
  ]))
}